import { Typography } from "../Typography";

export const EmptyResultMessage = (): JSX.Element => {
  return (
    <Typography pt={2} align="center" gutterBottom>
      該当する検索結果はありません
    </Typography>
  );
};
